// ================= initHeroVideo.js =================
export default function initHeroVideo(root = document) {
    const el = root.querySelector('[data-hero-video]');
    if (!el) return;

    const video  = el.querySelector('.banner__video');
    const poster = el.dataset.poster || '';
    const srcMP4 = el.dataset.srcMp4 || el.dataset.srcmp4 || '';

    const DEBUG = /[?&]vdebug=1/.test(location.search);
    const log = (...a) => { if (DEBUG) console.log('[hero-video]', ...a); };

    const saveData = !!(navigator.connection && navigator.connection.saveData);
    const prefersReduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (saveData || prefersReduced || !srcMP4) {
        log('skip: saveData/reducedMotion/src missing', { saveData, prefersReduced, srcMP4 });
        return;
    }

    const host = el.closest('.banner--video') || el;

    // 1) ЛОК висоти на момент ініта (щоб не було стрибка макета)
    // беремо поточну рендерну висоту банера і фіксуємо її
    let lastH = host.getBoundingClientRect().height | 0;
    if (lastH > 0) {
        host.style.minHeight = lastH + 'px'; // не даємо банеру «стиснутись»/«роздутись»
    }

    // 2) Компенсація скролу, якщо висота банера зміниться пізніше
    const scEl = document.scrollingElement || document.documentElement;
    const compensate = (newH) => {
        lastH = newH | 0;
    };
    if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => {
            const h = host.getBoundingClientRect().height;
            compensate(h);
        });
        ro.observe(host);
    }

    if (poster) video.setAttribute('poster', poster);

    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.volume = 0;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');


    const source = document.createElement('source');
    source.src = srcMP4;
    source.type = 'video/mp4';
    video.appendChild(source);
    try { video.load(); } catch(e) {}
    log('source appended', { src: srcMP4 });

    const markReady = () => {
        host.classList.add('is-video-ready');
        // важливо: висоту не прибираємо насильно — її стабілізує CSS (див. нижче)
    };
    let readyShown = false;
    function showOnce(){ if (!readyShown){ readyShown = true; markReady(); log('ready -> show'); } }

    video.addEventListener('loadedmetadata', showOnce, { once: true });
    video.addEventListener('loadeddata',     showOnce, { once: true });
    video.addEventListener('canplay',        showOnce, { once: true });
    video.addEventListener('canplaythrough', showOnce, { once: true });
    video.addEventListener('error', (e) => log('video error', e, video.error), { once: true });

    const tryPlay = () => {
        log('tryPlay()');
        const p = video.play();
        if (p && typeof p.catch === 'function') {
            p.catch(err => log('autoplay blocked', err));
        }
    };

    if (document.readyState === 'complete') tryPlay();
    else window.addEventListener('load', tryPlay, { once: true });

    if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([entry]) => {
            if (!entry) return;
            if (entry.isIntersecting) { tryPlay(); }
            else { video.pause(); }
        }, { threshold: 0.15 });
        io.observe(el);
    }
}
// ================= /initHeroVideo.js =================
